import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { FloorPlanViewer } from '../../components/floor-plan';
import {
  managementBuildingUrl,
  managementFloorEditUrl,
  managementFloorHistoryUrl,
} from './urls';

const ManagementFloorPlanPage = () => {
  const { branchId, buildingId, floorId } = useParams();
  const navigate = useNavigate();

  const goBack = () => {
    navigate(managementBuildingUrl(branchId, buildingId));
  };

  return (
    <div className="m-3 rounded-3xl border border-gray-200 bg-white px-3 py-3 md:m-5 md:px-5 md:py-4">
      <FloorPlanViewer
        floorId={floorId}
        onBack={goBack}
        onEdit={() => navigate(managementFloorEditUrl(branchId, buildingId, floorId))}
        onHistory={() => navigate(managementFloorHistoryUrl(branchId, buildingId, floorId))}
      />
    </div>
  );
};

export default ManagementFloorPlanPage;
